// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1H9Te","resendInfoText":"OnGoingPaymentBox_resendInfoText__1f84t"};